<template>
	<div class="crossAnalysis">
		<div class="crossAnalysis_header">{{$t('DataRecycling.CrossChart')}}</div>
		<div class="crossAnalysis_main">
			<div class="main_btn">
				<div></div>
				<div style="margin-right:20px">
					<el-button size="medium" type="plain" @click="dialogVisible = true">{{$t('DataRecycling.AddCrossAnalysis')}}</el-button>
					<el-select size="medium" style="width: 125px; margin-left: 5px;" v-model="deriveText" :placeholder="$t('DataRecycling.PleaseSelect')" @change="exportAllCrossAnalysis">
						<el-option v-for="item in derive" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<!-- <el-button>分享</el-button> -->
				</div>
			</div>
			<div class="chart_area" v-if="CrossTabs.length !== 0">
				<div class="echar" v-for="(item, index) in CrossTabs" :key="item.id"><ChartLine :CrossTabs="item" :CrossTabsindex="index" @delchart="delchart"></ChartLine></div>
			</div>
			<div class="chart_area" v-else>
				<div class="chart_empty">
					<div>
						<img src="../assets/chart_empty.png" alt="" />
						<p class="chart_emptyP">{{$t('DataRecycling.NotCrossChart')}}</p>
						<el-button size="medium" class="chart_emptyBtn" type="primary" @click="dialogVisible = true">{{$t('DataRecycling.AddCrossAnalysis')}}</el-button>
					</div>
				</div>
			</div>
		</div>
		<!-- 对话框 -->
		<el-dialog :title="$t('DataRecycling.AddCrossChart')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
			<div class="analysis">
				<p class="analysis_p">{{$t('DataRecycling.CrossChartsSupport')}}</p>
				<div class="analysis_dy">
					{{$t('DataRecycling.Argument')}}：
					<el-form :model="Cross" ref="Cross" class="demo-dynamic">
						<el-form-item v-for="(domain, index) in Cross.dataIndependent" :key="index">
							<el-select size="medium" v-model="domain.value" :placeholder="$t('DataRecycling.PleaseSelect')" @change="IndependentId">
								<el-option v-for="item in IndependentSelection" :key="item.id" :label="item.questionsName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div class="analysis_dy">
					{{$t('DataRecycling.DependentVariable')}}：
					<el-form :model="Cross2" ref="Cross2" class="demo-dynamic">
						<el-form-item v-for="(domain, index) in Cross2.dataDependent" :key="index">
							<el-select size="medium" v-model="domain.value" :placeholder="$t('DataRecycling.PleaseSelect')" @change="DependentSel">
								<el-option v-for="item in IndependentSelection" :key="item.id" :label="item.questionsName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="crossData">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改提示" :visible.sync="hintdialogVisible" width="30%" :before-close="hinthandleClose" :close-on-click-modal="false">
			<div style="padding: 15px; text-indent: 2em"><span>{{$t('DataRecycling.ModifyQuestionnaireTip')}}</span></div>
		
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="hintdialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="handleConfirmClick">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import ChartLine from '../components/ChartLine.vue';

export default {
	components: {
		ChartLine
	},
	data() {
		return {
			next: null,
			hintdialogVisible:false,
			CrossAnalyNum: 0, //交叉分析图表
			NewCrossTabs: [], //显示的数据列表
			// 交叉分析全部数据
			CrossTabs: [],
			tableDataOne: [],
			tableData: [], // table
			dialogVisible: false,
			derive: [
				{
					label: 'Excle',
					value: 0
				},
				{
					label: 'Word',
					value: 1
				}
			],
			deriveText: this.$t('DataRecycling.Export'),
			reveal: [
				{
					label: this.$t('DataRecycling.HideChart'),
					value: 0
				},
				{
					label: this.$t('DataRecycling.HideTable'),
					value: 1
				}
			],
			revealText: this.$t('DataRecycling.DisplaySettings'),

			valueCol: '',
			valueRow: '',
			legend: {
				data: []
			},
			indicator: [],
			leidaData: [],
			// 多条自变量
			Cross: {
				dataIndependent: [
					{
						value: ''
					}
				]
			},
			// 自变量选择数据
			IndependentSelection: [],
			// 因变量
			Cross2: {
				dataDependent: [
					{
						value: ''
					}
				]
			},
			// 因变量选择数据
			dependentSelection: [],
			crossx: '',
			crossy: '',

			type: 1,
			tabdataX: [],
			tableY: [],
			// 所有交叉分析的内容
			chartData: [],
			stackedChartoption: {},
			RadarChartoption: {}
		};
	},
	beforeRouteLeave(to, from, next) {
		// 导航离开该组件的对应路由时调用
		// 可以访问组件实例 `this`
		if (to.name != 'QuestionType') {
			next();
		} else {
			let state = sessionStorage.getItem('wstate');
			if (state && state != 1) {
				this.next = next;
				this.hintdialogVisible = true;
			} else {
				next();
			}
		}
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid') || 0;
		this.loadindependentV();
		this.queryCrossAnalysis(); //查询已有的交叉分析
	},
	methods: {
		hinthandleClose() {
			this.hintdialogVisible = false;
		},
		handleConfirmClick() {
			this.hintdialogVisible = false;
			this.wid = sessionStorage.getItem('wid') || 0;
			this.$api.UpdateQuestionnaireState({
				id: this.wid,
				state: 1
			});
			this.next();
		},
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		// 删除
		delchart(id, index) {
			console.log(id, index);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.delete}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.CrossTabs.splice(index, 1);
						that.$message({
							showClose: true,
							message: res.message,
							type: 'success'
						});
					}
				}
			};
			this.$util.request(params);
		},
		// 导出交叉分析  全部
		exportAllCrossAnalysis(value) {
			console.log(value);
			console.log(this.CrossTabs);
			let AllCross = [];
			this.CrossTabs.forEach(item => {
				AllCross.push(item.id);
			});
			let id = this.wid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportAllCrossAnalysis}?id=${id}&Authorization=Bearer${window.localStorage.getItem('token')}`,
				method: 'POST',
				data: {
					id: id,
					questionList: AllCross,
					state: value
				},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		// 添加交叉分析
		crossData() {
			// 多条自变量
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addCrossAnalyse}`,
				method: 'POST',
				data: {
					crossx: that.crossx,
					crossy: that.crossy,
					id: that.wid
				},
				cb(res) {
					if (res.code == 0) {
						that.dialogVisible = false;
						// console.log(that.CrossTabs)
						that.CrossTabs.unshift(res.resultBody);
					}
				}
			};
			this.$util.request(params);
		},

		// 查询因变量自变量选项
		loadindependentV() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addCross}`,
				method: 'POST',
				data: {
					id: that.wid
				},
				cb(res) {
					if (res.code == 0) {
						let IndependentSelection = res.resultBody;
						IndependentSelection.forEach(item => {
							item.questionsName = that.htmlToString(item.questionsName);
						});
						that.IndependentSelection = IndependentSelection;
					} else {
						that.IndependentSelection = [];
					}
				}
			};
			this.$util.request(params);
		},
		// 查询问卷的交叉分析
		queryCrossAnalysis() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryCrossAnalyze}?questionnaireId=${that.wid}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.CrossTabs = res.resultBody.datas;
					}
				}
			};
			this.$util.request(params);
		},

		// 添加因变量
		addDataDependent() {
			this.Cross2.dataDependent.push({
				value: '',
				key: Date.now()
			});
		},
		// 添加自变量
		addData() {
			this.Cross.dataIndependent.push({
				value: '',
				key: Date.now()
			});
		},
		// 添加交叉分析因变量id
		DependentSel(id) {
			this.crossy = id;
		},
		// 添加交叉分析自变量id
		IndependentId(id) {
			this.crossx = id;
		},
		// 关闭模态框
		handleClose(done) {
			done();
		}
	}
};
</script>

<style scoped lang="scss">
.crossAnalysis {
	padding: 20px 0 0 0px;
	height: 100%;
	min-width: 400px;
	.crossAnalysis_header {
		border-left: 2px solid #2672ff;
		padding-left: 5px;
		color: #484848;
		font-weight: 500;
	}
	.crossAnalysis_main {
		padding-top: 20px;
		height: 100%;
		.main_btn {
			width: 100%;
			// height: 65px;
			// line-height: 65px;
			background: #fff;
			display: flex;
			justify-content: space-between;
			margin-bottom: 20px;
		}
		.chart_area {
			width: 100%;
			height: 100%;
			background-color: #fff;
			text-align: center;
			.chart_empty {
				border-top: 1px solid #eaeaea;
				height: 80vh;
				display: flex;
				flex-direction: column;
				justify-content: center;
				.chart_emptyP {
					// line-height: 80vh;
					font-size: 16px;
					margin-bottom: 45px;
					margin-top: 10px;
				}
				.chart_emptyBtn {
					margin: auto;
					margin-bottom: 360px;
				}
			}
		}
	}
	.analysis {
		text-align: center;
		.analysis_p {
			font-size: 14px;
			color: #cccccc;
		}
		.analysis_dy {
			display: flex;
			width: 100%;
			height: 60px;
			line-height: 60px;
			margin: auto;
			.demo-dynamic {
				margin-top: 10px;
				// width: 100px;
			}
		}
	}
}
</style>
